$(document).ready(function(){
    
  // Build a Box small print
  setTimeout(function(){
    /*$(".rt-Box.rt-r-py-2").append("<div class='bbsmallprint discountsmallprint'>Discount automatically applied at check out.</div> ");*/
    $(".rt-Flex.rt-r-fd-row.rt-r-jc-space-between.rt-r-gap-2").prepend("<div class='bbsmallprint discountsmallprint desktop'>Discount automatically applied at check out. Not combinable with other discounts.</div> ");


    
        $(".bb-details__info-popover").prepend("<div class='bbsmallprint discountsmallprint'>Discount automatically applied at check out. Not combinable with other discounts.</div> ");

    

    /* const elements = document.querySelectorAll('.rt-Box.rt-r-py-2');
  
    // Check if there are elements with the class
    if (elements.length > 0) {
      // Get the last element
      const lastElement = elements[elements.length - 1];
    
      // Create the new element you want to add
      const newElement = document.createElement('div');
      newElement.textContent = 'Discount automatically applied at check out.';
      newElement.classList.add("bbsmallprint");
      newElement.classList.add("discountsmallprint");
    
      // Append the new element to the last element
      lastElement.appendChild(newElement);
    }
*/
    
  }, 3000);

  
 /* $("#bxp-bldr-bottom-wizard").append("<div class='bbsmallprint'>* Once you click <b>COMPLETE ORDER</b> and go to the cart, you will not be able to modify your bundle.</div> ");
*/
  $(".bxp-details-price").text(function(index, text) { 
    return text.replace(':', ' '); 
  });

  $("body").on('DOMSubtreeModified', "#bxp-bldr-total_value", function() {
      setTimeout(function(){  
        $(".bxp-details-price").text(function(index, text) { 
        return text.replace(':', ' '); 
        });
      }, 500);
  });

});